import {
  VideoQualityProfiles,
  type VideoQualityConstraint,
  VideoQualityProfilesWide,
} from './media.constants';

/**
 * Extracts numeric value from ConstrainDouble object using priority order of ideal > exact > min
 */
const extractConstraintValue = (
  constraint: number | ConstrainDouble | undefined,
): number | undefined => {
  if (!constraint) {
    return undefined;
  }

  if (typeof constraint === 'object') {
    return constraint.ideal ?? constraint.exact ?? constraint.min;
  }

  return constraint;
};

/**
 * Converts MediaTrackConstraints to VideoQualityConstraint by extracting numeric values
 * from ConstrainDouble objects using a priority order of ideal > exact > min
 */
export const convertToVideoQualityConstraint = (
  constraints?: MediaTrackConstraints,
): VideoQualityConstraint | undefined => {
  if (!constraints) {
    return undefined;
  }

  const width = extractConstraintValue(constraints.width) || 0;
  const height = extractConstraintValue(constraints.height) || 0;
  const resolution =
    width > height ? `${width}x${height}` : `${height}x${width}`;

  for (const [, profile] of Object.entries(VideoQualityProfiles)) {
    if (profile.resolution === resolution) {
      return profile;
    }
  }

  for (const [, profile] of Object.entries(VideoQualityProfilesWide)) {
    if (profile.resolution === resolution) {
      return profile;
    }
  }

  return undefined;
};
